import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { applyMiddleware, createStore, compose } from "redux";
import { apiMiddleware } from "redux-api-middleware";
import { createAuthMiddleware } from "@tshio/redux-api-auth-middleware";
import thunk from "redux-thunk";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import oAuthMiddleware from "./middleware/oauthMiddleware";
import passcodeMiddleware from "./middleware/passcodeMiddleware";
import billingMiddleware from "./middleware/billingMiddleware";
import projectmailMiddleware from "./middleware/projectmailMiddleware";
import rootReducer from "./reducers";

const authMiddleware = createAuthMiddleware({
  authConfig: {
    header: "Authorization",
    type: "Bearer",
  },
});

const store = compose(
  applyMiddleware(
    authMiddleware,
    apiMiddleware,
    thunk,
    oAuthMiddleware,
    passcodeMiddleware,
    billingMiddleware,
    projectmailMiddleware
  )
)(createStore)(rootReducer);

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
